
//  --------------------------------------------------
//  grid-template-areas 형식으로 매핑

import { IMainGrid } from "@typings/setting/MainHomeSecType";

//  --------------------------------------------------
export const generateGridTemplateAreas = ({
  gridSize,
  data,
}: {
  gridSize: { rows: number; cols: number };
  data: IMainGrid;
}) => {
  const grid: string[][] = Array(gridSize.rows)
    .fill(null)
    .map(() => Array(gridSize.cols).fill('.')); // 빈 그리드 초기화
  const dataArray = Object.values(data);

  // demoData를 grid에 매핑
  dataArray.forEach((group) => {
    group.cells.forEach(({ row, col }) => {
      // row, col 값이 grid의 범위 내에 있는지 확인
      if (row >= 0 && row < gridSize.rows && col >= 0 && col < gridSize.cols) {
        grid[row][col] = `${group.status}`;
      } else {
        console.warn(`Invalid row: ${row} or col: ${col}`);
      }
    });
  });

  // 마지막 행은 항상 'footer'로 채우기
  const lastRowIndex = gridSize.rows;
  grid[lastRowIndex] = Array(gridSize.cols).fill('footer');

  // grid-template-areas 형식으로 변환
  const templateAreas = grid
    .map((row) => `'${row.join(' ').trim()}'`)
    .join('\n');
  return templateAreas;
};

//  --------------------------------------------------
//  모바일 버전에서 grid-template-area
//  --------------------------------------------------
export const generateMobileGridTemplateAreas = ({
  groupedByStatus,
  gridSize,
}: {
  groupedByStatus: any;
  gridSize: { rows: number; cols: number };
  data: IMainGrid;
}) => {
  const statusKeys = Object.keys(groupedByStatus);

  statusKeys.push('footer');
  const templateAreas = statusKeys.map((row) => `'${row.trim()}'`).join('\n');

  return templateAreas;
};

//  --------------------------------------------------
//  grid-template-rows 매핑
//  --------------------------------------------------
export const generateGridTemplateRows = (gridTemplateAreas: string) => {
  // grid-template-areas를 행별로 나누기
  const rows = gridTemplateAreas.trim().split('\n');

  // 각 행을 [1fr, 1fr, ...] 형식으로 치환
  const rowValues = rows.map((rowStatus, index) => {
    // 마지막 행이면 footer 크기 반환
    if (index === rows.length - 1) {
      return '30px';
    }

    if (rowStatus.includes('marquee')) {
      return '30px';
    } else {
      return '1fr';
    }
  });

  // 결과적으로 grid-template-rows로 사용할 값 생성
  return rowValues.join(' ');
};

//  --------------------------------------------------
//  mobile grid-template-rows 매핑
//  --------------------------------------------------
export const generateMobileGridTemplateRows = (
  groupedByStatusData: any,
  gridTemplateAreas: string,
) => {
  // grid-template-areas를 행별로 나누기
  const statusKeys: string[] = Object.keys(groupedByStatusData);

  const rowValues = statusKeys.map((rowStatus, index) => {
    if (rowStatus.includes('slide')) {
      return '200px';
    }
    if (rowStatus.includes('marquee')) {
      return '30px';
    } else {
      return 'minmax(90px, auto)';
    }
  });

  // 결과적으로 grid-template-rows로 사용할 값 생성
  return rowValues.join(' ');
};

//  --------------------------------------------------
// groupedByStatusData를 처리하는 함수
//  --------------------------------------------------
export function groupAndSortByStatus(gridData: IMainGrid) {
  const groupedData = Object.values(gridData).reduce((acc, curr) => {
    const { status, order } = curr;
    if (!acc[status]) {
      acc[status] = [];
    }
    acc[status].push(curr);
    return acc;
  }, {});

  const sortedGroupedData = Object.entries(groupedData)
    .map(([status, items]: [any, any]) => [
      status,
      items.sort((a, b) => a.order - b.order), // order 기준 정렬
    ])
    .sort((a, b) => a[1][0].order - b[1][0].order); // 첫 번째 항목의 order 기준으로 그룹 정렬

  return Object.fromEntries(sortedGroupedData);
}
